module.exports = __webpack_public_path__ + "img/swap_vertical_circle.57ddb6c5.svg";